module.exports = __webpack_public_path__ + "media/markers/sailboat_grn-45cfd6d4.svg";